<script setup lang="ts">
import { computed } from 'vue'
import type { StatusTone } from '../tokens'
import ZhStatusPill from './ZhStatusPill.vue'

const props = defineProps<{ state: 'idle' | 'checking' | 'passed' | 'failed' }>()
const tone = computed<StatusTone>(
    () => (({ idle: 'neutral', checking: 'running', passed: 'completed', failed: 'failed' }) as const)[props.state],
)
const label = computed(
    () => ({ idle: 'Not checked', checking: 'Checking', passed: 'Found', failed: 'Missing' })[props.state],
)
</script>

<template>
    <tr class="zh-check-row border-input border-t" :data-state="state" :aria-busy="state === 'checking'">
        <slot />
        <td class="py-2" role="status"><ZhStatusPill :tone="tone">{{ label }}</ZhStatusPill></td>
    </tr>
</template>

<style scoped>
.zh-check-row[data-state='passed'] { --zh-check-colour: var(--state-complete); }
.zh-check-row[data-state='failed'] { --zh-check-colour: var(--state-failed); }
@media (prefers-reduced-motion: no-preference) {
    .zh-check-row[data-state='passed'], .zh-check-row[data-state='failed'] {
        animation: zh-check-wash var(--motion-decision) ease-out;
    }
    @keyframes zh-check-wash {
        from { background: color-mix(in srgb, var(--zh-check-colour) 18%, transparent); }
        to { background: transparent; }
    }
}
</style>
